export type SearchSummaryHeaderProps = {
    symbol?: string;
    firstLine: string;
    secondLine: string;
    thirdLine: string;
    fourthLine?: string;
};

export const SearchSummaryHeader = (props: SearchSummaryHeaderProps) => {
    const { symbol, firstLine, secondLine, thirdLine, fourthLine } = props;

    return (
        <div className="search-summary__header">
            {symbol && (
                <div className="search-summary__icon">
                    <svg className="search-summary__header__symbol">
                        <use href={`/assets/lib-ui-primitive/icons/icon.svg#${symbol}`} />
                    </svg>
                </div>
            )}

            <div className="search-summary__header__product">
                {firstLine && <p className="search-summary__header__product__first-line">{firstLine}</p>}
                <p className="search-summary__header__product__second-line">{secondLine}</p>
                <p className="search-summary__header__product__third-line">{thirdLine}</p>
                {fourthLine && <p className="search-summary__header__product__fourth-line">{fourthLine}</p>}
            </div>
        </div>
    );
};
